import React, { useState } from "react";
import axios from "axios";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';

interface UploadProps {
  onUploaded?: () => void;
}

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:8000";

export default function Upload({
  onUploaded,
}: UploadProps) {

  const [file, setFile] = useState<File | null>(null);

  const [uploading, setUploading] = useState(false);

  const [message, setMessage] = useState("");

  const handleUpload = async () => {

    if (!file) return;

    const formData = new FormData();

    formData.append("file", file);

    setUploading(true);

    setMessage("");

    try {

      const response = await axios.post(
        `${API_BASE_URL}/api/documents/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setMessage(response.data.message);

      onUploaded?.();

      setFile(null);

    } catch (error: any) {

      setMessage(
        error.response?.data?.message ||
        "Upload failed."
      );

    } finally {

      setUploading(false);

    }

  };

  return (

    <div className="upload-card">

      <label className="upload-dropzone">

        <div className="upload-icon">
          <FontAwesomeIcon icon={faFileAlt} />
        </div>

        <h5>

          Upload PDF

        </h5>

        <p>

          Click to choose your document

        </p>

        <input
          type="file"
          accept=".pdf"
          hidden
          onChange={(e) => {

            if (e.target.files) {

              setFile(e.target.files[0]);

            }

          }}
        />

      </label>

      {file && (

        <div className="selected-file">

          <span>

            {file.name}

          </span>

          <button
            onClick={() => setFile(null)}
          >
            ✕

          </button>

        </div>

      )}

      <button
        className="upload-btn"
        disabled={!file || uploading}
        onClick={handleUpload}
      >

        {uploading
          ? "Uploading..."
          : "Upload PDF"}

      </button>

      {message && (

        <div className="upload-message">

          {message}

        </div>

      )}

    </div>

  );

}